import { Link } from "react-router-dom";
import { ArrowRight, Code2 } from "lucide-react";

const REFS = [
  { slug: "aquatec", name: "aquatec-shop.de", what: "Onlineshop mit Konfigurator & Warenwirtschaft", url: "https://aquatec-shop.de" },
  { slug: "voicenrw", name: "voice.nrw", what: "Sprecherplattform mit Audio-Casting", url: "https://voice.nrw" },
  { slug: "newzer", name: "newzer.de", what: "SaaS – Frühwarnsystem für öffentliche Informationen", url: "https://newzer.de" },
];

export const IndividualBox = ({ dark = true }) => (
  <section id="individuell" className={`mx-auto max-w-[1500px] px-5 md:px-10 mt-24 md:mt-32 scroll-mt-28 ${dark ? "" : "text-[#111]"}`} data-testid="individual-box">
    <div className={`rounded-3xl border p-7 md:p-12 ${dark ? "border-gold/40 bg-white/[0.03]" : "border-[#111] bg-white"}`}>
      <div className="lg:flex lg:items-end lg:justify-between gap-10">
        <div className="max-w-xl">
          <p className={`text-[11px] uppercase tracking-[0.3em] mb-4 inline-flex items-center gap-2 ${dark ? "text-gold" : "text-[#B88E3E]"}`}><Code2 size={13} /> Oder soll es komplett individuell sein?</p>
          <h2 className={`font-display text-3xl md:text-4xl leading-[1.05] ${dark ? "text-paper" : "text-[#111]"}`}>Wir programmieren natürlich auch komplett individuell<span className={dark ? "text-gold" : "text-[#FDD105]"}>.</span></h2>
          <p className={`mt-4 leading-relaxed ${dark ? "text-grey" : "text-[#4A4A4A]"}`}>Onlineshops, Plattformen, Software mit eigener Logik – wenn der Baukasten nicht reicht, entwickeln wir maßgeschneidert. Drei Beispiele aus unserer Werkstatt:</p>
        </div>
        <Link to="/kontakt" className={`mt-6 lg:mt-0 shrink-0 inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] ${dark ? "bg-gold text-ink" : "bg-[#111] text-[#FDD105]"}`} data-testid="individual-box-contact">Nimm Kontakt auf <ArrowRight size={14} /></Link>
      </div>
      <div className="mt-10 grid gap-5 md:grid-cols-3">
        {REFS.map((r) => (
          <a key={r.slug} href={r.url} target="_blank" rel="noopener noreferrer" className={`group block rounded-2xl overflow-hidden border transition-transform duration-300 hover:-translate-y-1 ${dark ? "border-white/10 bg-ink/60" : "border-[#E2E2DD] bg-[#F6F6F2]"}`} data-testid={`individual-ref-${r.slug}`}>
            <div className="aspect-[12/5] overflow-hidden bg-[#111]">
              <img src={`/img/referenzen/${r.slug}.webp`} alt={`Screenshot ${r.name}`} loading="lazy" className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]" />
            </div>
            <div className="p-4">
              <p className={`font-semibold ${dark ? "text-paper" : "text-[#111]"}`}>{r.name}</p>
              <p className={`text-xs mt-1 ${dark ? "text-grey" : "text-[#4A4A4A]"}`}>{r.what}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
